module.exports = __webpack_public_path__ + "img/avatar.32e9a32d.png";